import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { RequestForm } from './pages/RequestForm';
import { Success } from './pages/Success';
import { RequestHistoryPage } from './pages/RequestHistoryPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Landing data-id="element-3" />} data-id="element-2" />
        <Route path="/request" element={<RequestForm data-id="element-5" />} data-id="element-4" />
        <Route path="/success" element={<Success data-id="element-7" />} data-id="element-6" />
        <Route path="/history" element={<RequestHistoryPage data-id="element-9" />} data-id="element-8" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-11" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}